@if ({
  priceMediaTabs: priceMediaTabs$ | async
  }; as content) {
  <div class="simple-card">
    <page-title></page-title>
  </div>
  <div class="simple-card m-t-20">
    @if (priceMediaCurrentTab) {
      <tab-options
        [options]="content.priceMediaTabs || []"
        [(currentOption)]="priceMediaCurrentTab">
      </tab-options>
      @if (priceMediaCurrentTab.code === PRICE_MEDIA_TABS.PRICE_MEDIA_HISTORY) {
        <price-media-history></price-media-history>
      }
      @if (priceMediaCurrentTab.code === PRICE_MEDIA_TABS.PRICE_MEDIA_REQUEST) {
        <price-media-request></price-media-request>
      }
    }
  </div>
}
